export { ProductIcon } from './components/ProductIcon';
export type { ProductName, ProductKey, UiProductType } from './types';
export {
  getProductDisplayName,
  getProductConfig,
  getProductConfigByKey,
  PRODUCT_LOGO_MAP,
  getProductType,
} from './components/productConfig';
export { getVisibleApps, isVisibleApp } from './components/visibleApps';
export { sortProducts } from './utils/sortProducts';
